export default () => (
  <svg width="18" height="18" viewBox="0 0 19 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M9 0.5H0V9.5H9V0.5Z" fill="#F25022"></path>
    <path d="M9 10.5H0V19.5H9V10.5Z" fill="#00A4EF"></path>
    <path d="M19 0.5H10V9.5H19V0.5Z" fill="#7FBA00"></path>
    <path d="M19 10.5H10V19.5H19V10.5Z" fill="#FFB900"></path>
  </svg>
)
